<template>
  <vs-popup class="msds-search-popup" title="화학물질정보(MSDS) 검색" :active.sync="showPopup">
    <p class="guide-text mb-4">안전보건공단 화학물질정보 OPEN API에서 물질을 검색해 유해ㆍ위험문구 / 예방조치문구를 불러옵니다.</p>

    <div class="flex gap-2 mb-4">
      <vs-select v-model="searchCnd" style="width: 130px">
        <vs-select-item v-for="opt in searchCndOptions" :key="opt.value" :value="opt.value" :text="opt.text" />
      </vs-select>
      <vs-input class="flex-1" v-model="searchWrd" placeholder="예: 벤젠" @keyup.enter="handleSearch" />
      <vs-button color="secondary" :disabled="searching" @click="handleSearch">검색</vs-button>
    </div>

    <div class="w-full" style="overflow-x: auto">
      <table>
        <colgroup>
          <col width="200" />
          <col width="140" />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th>화학물질명</th>
            <th>CAS No.</th>
            <th>최종 갱신일</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="searching">
            <td colspan="3" class="empty-row">검색 중입니다...</td>
          </tr>
          <tr v-else-if="chemList.length === 0">
            <td colspan="3" class="empty-row">검색어를 입력하고 검색해주세요.</td>
          </tr>
          <tr v-for="chem in chemList" :key="chem.chemId" @click="handleSelectChem(chem)">
            <td>{{ chem.chemNameKor }}</td>
            <td>{{ chem.casNo }}</td>
            <td>{{ chem.lastDate }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex justify-end gap-4 mt-6">
      <vs-button color="secondary" type="border" @click="cancel">닫기</vs-button>
    </div>
  </vs-popup>
</template>

<script>
import { searchChemList, getChemHazardDetail, extractWarningStatements } from "./msdsOpenApi";

export default {
  name: "PopupMSDSSearch",
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      showPopup: this.value,
      searchCnd: 0,
      searchCndOptions: [
        { value: 0, text: "국문명" },
        { value: 1, text: "CAS No." },
        { value: 2, text: "UN No." },
        { value: 3, text: "KE No." },
        { value: 4, text: "EN No." },
      ],
      searchWrd: "",
      searching: false,
      chemList: [],
    };
  },
  watch: {
    value: {
      handler(value) {
        this.showPopup = value;
        if (value) {
          this.searchWrd = "";
          this.chemList = [];
        }
      },
    },
    showPopup(value) {
      this.$emit("input", value);
    },
  },
  methods: {
    cancel() {
      this.showPopup = false;
    },
    async handleSearch() {
      if (!this.searchWrd) {
        this.$vs.notify({ title: "알림", text: "검색어를 입력해주세요.", color: "warning" });
        return;
      }
      this.searching = true;
      try {
        this.chemList = await searchChemList({ searchWrd: this.searchWrd, searchCnd: this.searchCnd });
        if (this.chemList.length === 0) {
          this.$vs.notify({ title: "알림", text: "검색된 물질이 없습니다.", color: "warning" });
        }
      } catch (err) {
        this.$vs.notify({ title: "MSDS 검색 실패", text: err.message, color: "danger" });
      } finally {
        this.searching = false;
      }
    },
    async handleSelectChem(chem) {
      this.searching = true;
      try {
        const hazardDetail = await getChemHazardDetail(chem.chemId, chem.lastDate);
        const { 유해위험문구, 예방조치문구 } = extractWarningStatements(hazardDetail);
        if (유해위험문구.length === 0 && 예방조치문구.length === 0) {
          this.$vs.notify({ title: "알림", text: "해당 물질의 유해ㆍ위험문구 / 예방조치문구 정보가 없습니다.", color: "warning" });
          return;
        }
        this.$emit("select", { chemNameKor: chem.chemNameKor, 유해위험문구, 예방조치문구 });
        this.showPopup = false;
      } catch (err) {
        this.$vs.notify({ title: "MSDS 조회 실패", text: err.message, color: "danger" });
      } finally {
        this.searching = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.msds-search-popup::v-deep {
  .vs-popup {
    width: 90%;
    @media (min-width: 768px) {
      width: 640px;
    }
  }
}

.guide-text {
  font-size: 13px;
  color: #888;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    text-align: center;
    border: 1px solid #cdcdcd;
    padding: 7px 11px;
  }

  th {
    font-weight: 700;
    background-color: #f9f9f9;
  }

  tbody tr:not(:first-child) {
    cursor: pointer;
    &:hover {
      background-color: #f0f0fd;
    }
  }

  .empty-row {
    padding: 20px 0;
    color: #999;
    cursor: default;
  }
}
</style>
